import { IQuickSortState } from "../../IQuickSortState";
import { IQuickSortContext } from '../../IQuickSortContext';
import { QuickSortStep } from '../../enums/QuickSortStep';
import { assertIsDefined } from "../../../tsutils/assertIsDefined";
import { PartitionEntryState } from "./PartitionEntryState";

export class QuickSortCallPartitionState implements IQuickSortState {

  ThisQuickSortStep = QuickSortStep.QuickSortCallPartition;
  
  Description = "Call Partition Function";

  private _savedState : { 
    PushedObjects: Array<any> | undefined
   } | undefined;

  private _context : IQuickSortContext | undefined;
  
  SetContext(context: IQuickSortContext): void {
    this._context = context;
  } 
  
  Do(): void {
    assertIsDefined(this._context);
    assertIsDefined(this._context.Numbers);
    assertIsDefined(this._context.AlgoStack);
    assertIsDefined(this._context.Lo);
    assertIsDefined(this._context.Hi);

    let numbers: Array<number> = this._context.Numbers;
    let lo: number = this._context.Lo;
    let hi: number = this._context.Hi;

    if (this._savedState === undefined) {
      this._savedState = {
        PushedObjects: [numbers, lo, hi]
      }
    }
    else {
      this._savedState.PushedObjects = [numbers, lo, hi];
    }

    this._context.AlgoStack.push(hi);
    this._context.AlgoStack.push(lo);
    this._context.AlgoStack.push(numbers);
  }

  Undo(): void {
    assertIsDefined(this._context);
    assertIsDefined(this._context.AlgoStack);

    this._context.AlgoStack.pop();
    this._context.AlgoStack.pop();
    this._context.AlgoStack.pop();    
  }

  Exit(): void {
    assertIsDefined(this._context);
    this._context.TransitionTo(new PartitionEntryState())
  }
}